import { Stack, useLocalSearchParams } from 'expo-router';

import { FruitSliceListenerPage } from '../../../../../fruit-slices/components/FruitSliceListenerPage';
import { FruitSlicePageBackground } from '../../../../../fruit-slices/components/FruitSlicePageBackground';

export default function FruitSliceListenerDetailPage() {
    const { id, listenerId } = useLocalSearchParams<{
        id: string;
        listenerId: string;
    }>();

    return (
        <>
            <Stack.Screen options={{ title: 'Fruit Slice Listener' }} />
            <FruitSlicePageBackground>
                <FruitSliceListenerPage sliceId={id} listenerId={listenerId} />
            </FruitSlicePageBackground>
        </>
    );
}
